import React, { useEffect, useState } from "react";
import { URLS } from "../../urls";
import { Link } from "react-router-dom";
import "../../../assets/css/sidebar.css";
import { fetchActionsUtil, useCookie } from "../../../utils";

const UserSidebar = () => {
  const user_Id = useCookie("userId");

  const [token, setToken] = useState("");
  const [isLineManager, setIsLineManager] = useState(false);

  const fetchData = async () => {
    try {
      const tokenData = fetchActionsUtil(
        `${URLS.backendUsers}/get-attendance-generated-token?userId=${user_Id}`
      );

      const [tokenResult] = await Promise.all([tokenData]);

      setToken(tokenResult?.token);
      setIsLineManager(tokenResult?.isLineManager);
    } catch (error) {
      console.log({ error });
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchData();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const scrollParent = {
    height: "100%",
    paddingBottom: "70px",
    overflow: "hidden",
    width: "14.688rem",
  };
  const scrollChild = {
    width: "100%",
    height: "100%",
    overflow: "auto",
    boxSizing: "content-box",
  };

  return (
    <div className="sidebar sidebar-update" id="sidebar" style={scrollParent}>
      <div className="sidebar-inner" style={scrollChild}>
        <div id="sidebar-menu" className="sidebar-menu">
          <ul>
            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardProfile} className="side-anchor">
                <span className="icon">
                  <i className="la la-users"></i>
                </span>
                <span>Profile</span>
              </Link>
            </li>

            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardPolicy} className="side-anchor">
                <span className="icon">
                  <i className="la la-file-pdf-o"></i>
                </span>
                <span>Policies</span>
              </Link>
            </li>
            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardLeaves} className="side-anchor">
                <span className="icon">
                  <i className="la la-hourglass-start"></i>
                </span>
                <span>Leaves</span>
              </Link>
            </li>
            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardLoan} className="side-anchor">
                <span className="icon">
                  <i className="la la-money"></i>
                </span>
                <span>Loan</span>
              </Link>
            </li>
            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardAllowance} className="side-anchor">
                <span className="icon">
                  <i className="la la-tasks"></i>
                </span>
                <span>Allowance</span>
              </Link>
            </li>
            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardMyAttendance} className="side-anchor">
                <span className="icon">
                  <i className="fa fa-calendar"></i>
                </span>
                <span>My attendance</span>
              </Link>
            </li>
            <li className="submenu-sidebar mt-2">
              <a
                href={`${URLS.mainSite}/requisition/request`}
                className="side-anchor"
              >
                <span className="icon">
                  <i className="la la-check-square-o"></i>
                </span>
                <span>Forms/Approval</span>
              </a>
            </li>
            <li className="submenu-sidebar mt-2">
              <Link to={URLS.userDashboardPermission} className="side-anchor">
                <span className="icon">
                  <i className="la la-check-square-o"></i>
                </span>
                <span>
                  Request <br />
                  Permission
                </span>
              </Link>
            </li>

            {isLineManager ? (
              <>
                <li className="submenu-sidebar mt-2">
                  <Link
                    to={URLS.UserEmployeesDirectReport}
                    className="side-anchor"
                  >
                    <span className="icon">
                      <i className="fa fa-users"></i>
                    </span>
                    <span>Direct Report</span>
                  </Link>
                </li>

                <li className="submenu-sidebar mt-2">
                  <a
                    href={`${URLS.takeAttendance}?token=${token}`}
                    className="side-anchor"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="icon">
                      <i className="fa fa-address-book"></i>
                    </span>
                    <span>Take attendance </span>
                  </a>
                </li>
              </>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserSidebar;
